import { render, staticRenderFns } from "./documentiPolize.vue?vue&type=template&id=473ff251&"
import script from "./documentiPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./documentiPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports